import { Module } from "wrapper6";
import NavigationScrollHandler from '../utils/_navigation-scroll';

/*
 -------------------------------
 Class
 -------------------------------
 */

let $ = jQuery;

export default class Navigation extends Module {
	ready(app) {
		const MAIN_HEADER = document.querySelector('#main_header');

		if (document.querySelector('.mtt-cover-widget')) {
			document.querySelector('body').classList.add('has-cover');
		}

		new NavigationScrollHandler({
			scrollDistance: 80,
			headerElement: MAIN_HEADER,
			onEnter: addScrollClass,
			onExit: removeScrollClass
		});

		function addScrollClass() {
			if (!MAIN_HEADER.classList.contains('scrolled')) {
				MAIN_HEADER.classList.add('scrolled');
			}
		}

		function removeScrollClass() {
			if (MAIN_HEADER.classList.contains('scrolled')) {
				MAIN_HEADER.classList.remove('scrolled');
			}
		}

		/**
		 * Responsive Nav
		 */
		var pullMenu = $('.pull_menu'),
			line1 = $('.line-1'),
			line2 = $('.line-2'),
			line3 = $('.line-3'),
			nav = $('nav#main_nav'),
			canToggle = true,
			body = $('body');

		pullMenu.click(function() {
			if(canToggle) {
				canToggle = false;
				nav.css('transition', '300ms all ease');
				nav.toggleClass('pull_menu_in_out');
				line1.toggleClass('line-1-animate');
				line2.toggleClass('line-2-remove');
				line3.toggleClass('line-3-animate');
				body.toggleClass('no-scroll');

				setTimeout(function() {
					canToggle = true;
					nav.css('transition', 'none');
				}, 300);
			}
			// nav.css('transition', 'none');
			// body.toggleClass('no-scroll');
		});

		$('li.menu-item-has-children').each(function() {

			var item = $(this);
			var added = true;

			item.on('click', function(e) {			
				
				var ul = $(this).find('ul.sub-menu');
				var ulHeight = ul.height();

				$(this).addClass('rotate');

				if (added && e.target.tagName !== 'A') {

					$(this).css({
					    marginBottom: ulHeight
					});

					var time = 100;

					$(this).find('ul').children().each(function(index){
					    var obj = $(this);
					    setTimeout(function(){
					        $(obj).addClass('slide-in');
					    }, time);
					    time += 50;
					});

					added = false;

				} else {

					var thisObj = $(this);

					$(this).removeClass('rotate');

		            var time = 100;

		            $($(this).find('ul li').get().reverse()).each(function() {
		                var obj = $(this);
		                setTimeout(function(){
		                    $(obj).removeClass('slide-in');
		                }, time);
		                time += 50;
		            });

		            setTimeout(function(){
		                $(thisObj).css({
		                    marginBottom: '0px'
		                });
		            }, time);

		            added = true;

				}			

			});

		});
	}
}